import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-6 w-[650px] p-6 rounded-lg bg-white shadow-default" }
const _hoisted_2 = { class: "modal-heading" }
const _hoisted_3 = { class: "w-full pt-2" }
const _hoisted_4 = { class: "relative" }
const _hoisted_5 = {
  class: "label-primary",
  for: "add-widget-input"
}
const _hoisted_6 = ["placeholder"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { class: "absolute top-3.5 right-3" }
const _hoisted_9 = { class: "mt-1 text-xs text-critical-main" }
const _hoisted_10 = { class: "flex gap-4 self-end" }

import { ref } from "vue";
import axios from "axios";
import { useRouter } from "vue-router";
import { changeCase } from '../../helpers';
import { ElementE } from '../../enums';
import ErrorIcon from "../icons/ErrorIcon.vue";

const maxLength = 20;


export default /*#__PURE__*/_defineComponent({
  __name: 'AddWidgetModal',
  setup(__props) {

const router = useRouter();

const widgetName = ref<string>("");
const error = ref<string>("");
const validateField = (value: string) => {
  if (!value) {
    error.value = "The field should not be empty";
    return;
  }
  
  if (value.length > maxLength) {
    error.value = `The length of field must be less than ${maxLength} characters`;
    return;
  }
  
  error.value = "";
};

const addNewWidget = async() => {
  const token = sessionStorage.getItem("TOKEN");
  const config = {
    headers: { Authorization: `Bearer ${token}` },
  };
  const formData = new FormData();
  formData.append("name", widgetName.value);

  if (!widgetName.value) {
    error.value = "The field should not be empty"
  }

  if (!error.value) {
    try {
      const { data: { id }} = await axios.post(process.env.VUE_APP_API + "v3/widgets", formData, config);
      router.push({ name: "Edit Widget", params: { wid: id } });
    } catch (error) {
      console.error(error);
    }
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, _toDisplayString(_unref(changeCase)('add widget', _unref(ElementE).TITLE)), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("label", _hoisted_5, _toDisplayString(_unref(changeCase)('widget name', _unref(ElementE).LABEL)), 1),
        _withDirectives(_createElementVNode("input", {
          id: "add-widget-input",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((widgetName).value = $event)),
          class: _normalizeClass(["input-primary", error.value && 'border-critical']),
          type: "text",
          placeholder: (_unref(changeCase)('enter name', _unref(ElementE).PLACEHOLDER) as string),
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (validateField(widgetName.value)))
        }, null, 42, _hoisted_6), [
          [
            _vModelText,
            widgetName.value,
            void 0,
            { trim: true }
          ]
        ]),
        (error.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createVNode(ErrorIcon)
              ]),
              _createElementVNode("p", _hoisted_9, _toDisplayString(error.value), 1)
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _createElementVNode("div", _hoisted_10, [
      _createElementVNode("button", {
        class: "btn-secondary is-btn-size-default",
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('close')))
      }, _toDisplayString(_unref(changeCase)('cancel', _unref(ElementE).BUTTON)), 1),
      _createElementVNode("button", {
        class: "btn-primary is-btn-size-default",
        onClick: addNewWidget
      }, _toDisplayString(_unref(changeCase)('add', _unref(ElementE).BUTTON)), 1)
    ])
  ]))
}
}

})